import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { useUser } from '../auth';
import { isItAccess } from '../constants/Roles';

const IT_ACCESS_ALLOWED_PREFIXES = ['/management', '/no-permission', '/settings'];

const isAllowedForItAccess = (path) =>
	IT_ACCESS_ALLOWED_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));

const PrivateRoute = ({ component: Component, ...rest }) => {
	const { isSignedIn, user } = useUser();
	return (
		<Route
			{...rest}
			render={(props) => {
				if (!isSignedIn) return <Redirect to='/login' />;
				if (isItAccess(user) && !isAllowedForItAccess(props.location.pathname)) {
					return <Redirect to='/no-permission' />;
				}
				return <Component {...props} />;
			}}
		/>
	);
};

export default PrivateRoute;
